import { useMutation } from '@tanstack/react-query';

import { Competitions, type InviteCallParams } from '@app/client';

export const useJoinTeam = () => {
    return useMutation((value: InviteCallParams) => Competitions.callJoinTeam(value), { retry: false });
};
